import { NgIf } from "@angular/common";
import {
    afterRender,
    Component,
    ElementRef,
    OnInit,
    Renderer2,
} from '@angular/core';
import { DomSanitizer, SafeHtml } from "@angular/platform-browser";
import { ActivatedRoute } from "@angular/router";
import { PageViewApiService } from "@core/api/v1";
import { switchMap } from "rxjs";

@Component({
    selector: 'app-statische-seite',
    imports: [
        NgIf,
    ],
    templateUrl: './seite.component.html',
    standalone: true,
    styleUrl: './seite.component.scss',
})
export class SeiteComponent implements OnInit {

    titel: string | null;
    page: SafeHtml;
    error: boolean;

    constructor(private api: PageViewApiService,
                private route: ActivatedRoute,
                private sanitizer: DomSanitizer,
                private renderer: Renderer2,
                private elementRef: ElementRef) {

        afterRender(() => {
            let images = this.elementRef.nativeElement.querySelectorAll('img');

            images.forEach((img:HTMLImageElement) => {
                //TODO: url anpassen
                //renderer.setAttribute(img, 'src', 'src updated!')
            });
        })
    }

    ngOnInit(): void {
        this.route.url.pipe(switchMap(path => this.api.getPage(path[0].path))).subscribe(response => {
            this.titel = response.titel!;
            this.page = this.sanitizer.bypassSecurityTrustHtml('<style> div#page p {line-height: 1.5;} div#page h2 {line-height: 2;} div#page h3{line-height:1.7;} </style>' + response.seite!);
        }, error => {
            this.error = true
        });

    }
}
